import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height"]


export default /*@__PURE__*/_defineComponent({
  __name: 'HeadsetIcon',
  props: {
    size: { default: 20 },
    color: { default: undefined }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    class: "headset-icon",
    "aria-hidden": "true",
    viewBox: "0 0 1024 1024",
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    width: _ctx.size,
    height: _ctx.size,
    style: _normalizeStyle(_ctx.color ? { color: _ctx.color } : undefined)
  }, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M106.666667 490.666667C106.666667 266.816 288.149333 85.333333 512 85.333333s405.333333 181.482667 405.333333 405.333334v64h-1.770666c1.173333 6.933333 1.770667 14.08 1.770666 21.333333v42.666667c0 27.264-8.533333 52.544-23.04 73.301333 1.109333 3.818667 1.706667 7.850667 1.706667 12.032 0 106.026667-85.973333 234.666667-192 234.666667h-80.298667c-11.733333 13.098667-28.757333 21.333333-47.701333 21.333333h-42.666667a64 64 0 1 1 0-128h42.666667c18.965333 0 35.989333 8.234667 47.701333 21.333333H704c46.058667 0 85.290667-55.253333 100.224-107.52A128 128 0 0 1 661.333333 618.666667v-42.666667a128 128 0 0 1 168.661334-121.408C812.074667 294.848 676.544 170.666667 512 170.666667 347.456 170.666667 211.925333 294.826667 194.005333 454.592A128 128 0 0 1 362.666667 576v42.666667a128 128 0 0 1-256 0v-42.666667c0-7.253333 0.597333-14.4 1.770666-21.333333H106.666667v-64z m128 42.666666a42.666667 42.666667 0 0 0-42.666667 42.666667v42.666667a42.666667 42.666667 0 1 0 85.333333 0v-42.666667a42.666667 42.666667 0 0 0-42.666666-42.666667z m554.666666 0a42.666667 42.666667 0 0 0-42.666666 42.666667v42.666667a42.666667 42.666667 0 1 0 85.333333 0v-42.666667a42.666667 42.666667 0 0 0-42.666667-42.666667z",
      fill: "currentColor"
    }, null, -1)
  ]))], 12, _hoisted_1))
}
}

})